var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTableware = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.999 19V48C34.999 49.1046 35.8944 50 36.999 50C38.1036 50 38.999 49.1046 38.999 48V19H40.999V48C40.999 50.2091 39.2081 52 36.999 52C34.7899 52 32.999 50.2091 32.999 48V19H34.999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 0C31.5523 0 32 0.447715 32 1V14C32 16.7614 34.2386 19 37 19C39.7614 19 42 16.7614 42 14V1C42 0.447715 42.4477 0 43 0C43.5523 0 44 0.447715 44 1V14C44 17.866 40.866 21 37 21C33.134 21 30 17.866 30 14V1C30 0.447715 30.4477 0 31 0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99902 11.55C8.99902 12.1787 9.04472 12.9858 9.12152 13.8848C9.36802 16.7693 11.9045 19 14.999 19C18.0935 19 20.63 16.7693 20.8765 13.8848C20.9533 12.9858 20.999 12.1787 20.999 11.55C20.999 9.7667 20.4497 7.21704 19.3132 5.17129C18.1714 3.11612 16.7125 2 14.999 2C13.2855 2 11.8266 3.11612 10.6848 5.17129C9.54832 7.21704 8.99902 9.7667 8.99902 11.55ZM7.1288 14.055C7.04994 13.132 6.99902 12.2608 6.99902 11.55C6.99902 7.35 9.49902 0 14.999 0C20.499 0 22.999 7.35 22.999 11.55C22.999 12.2608 22.9481 13.132 22.8692 14.055C22.526 18.0722 19.0309 21 14.999 21C10.9671 21 7.47201 18.0722 7.1288 14.055Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 19V48C13 49.1046 13.8954 50 15 50C16.1046 50 17 49.1046 17 48V19H19V48C19 50.2091 17.2091 52 15 52C12.7909 52 11 50.2091 11 48V19H13Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.999 8H30.999V10H42.999V8Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.001 9.01784C34.001 9.56029 34.4487 10 35.001 10C35.5533 10 36.001 9.56029 36.001 9.01784V0.982209C36.001 0.439749 35.5533 0 35.001 0C34.4487 0 34.001 0.439749 34.001 0.982209V9.01784Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.001 9.01784C38.001 9.56029 38.4487 10 39.001 10C39.5533 10 40.001 9.56029 40.001 9.01784V0.982209C40.001 0.439749 39.5533 0 39.001 0C38.4487 0 38.001 0.439749 38.001 0.982209V9.01784Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTableware);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tableware.62d200da0a1b74cc1ad3660b5cfc0b72.svg";